/**
 * OCP registry for item actives / consumable use handlers.
 * New actives register here — InventorySystem never switches on item id.
 */

const handlers = new Map();

/**
 * @param {string} itemId
 * @param {(ctx: object) => { success: boolean, consume?: boolean, cooldownMs?: number, reason?: string }} handler
 */
export function registerItemActive(itemId, handler) {
  if (typeof itemId !== 'string' || !itemId) {
    throw new Error('itemId required');
  }
  if (typeof handler !== 'function') {
    throw new Error('handler must be a function');
  }
  handlers.set(itemId, handler);
}

export function getItemActiveHandler(itemId) {
  return handlers.get(itemId) || null;
}

export function hasItemActive(itemId) {
  return handlers.has(itemId);
}

/** Test-only */
export function _resetItemActiveRegistryForTests() {
  handlers.clear();
}
